import { useMutation } from "@/compat/reactQuery";
import incidentService from "../../services/incidentService";

const useAddIncident = () => useMutation(incidentService.addIncident);

export default useAddIncident;
